import {
  Toast,
  ToastAction,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "./Toast"
import { TOAST_DISMISS_DELAY, useToast } from "./useToast"

function Toaster() {
  const { toasts, dismiss, remove } = useToast()

  return (
    <ToastProvider>
      {toasts.map(
        ({ id, variant, title, description, icon, action, duration, open }) => (
          <Toast
            key={id}
            variant={variant}
            icon={icon}
            open={open}
            duration={duration ?? TOAST_DISMISS_DELAY}
            className="cursor-pointer"
            onClick={() => dismiss(id)}
            onOpenChange={(isOpen) => {
              if (!isOpen) {
                remove(id)
              }
            }}
          >
            {title && <ToastTitle>{title}</ToastTitle>}
            {description && <ToastDescription>{description}</ToastDescription>}
            {action && (
              <ToastAction altText={action.label} onClick={action.onClick}>
                {action.label}
              </ToastAction>
            )}
            <ToastClose />
          </Toast>
        ),
      )}
      <ToastViewport />
    </ToastProvider>
  )
}

export { Toaster }
